//import { BoilerActorType } from '../../../enums/boilerActorType';
import { TreeNode } from '@usimweb/core/models';

//FIX ME export to a enum class
export enum BoilerActorType {
  CONNECTOR = 'connections',
  HEAT_EXCHANGER = 'heatExchangers',
  CYLINDER = 'cylinder',
  AXES = 'axes',
  PATCH = 'patches',
}

export abstract class Helper {
  static Time = class {
    public static reformatDateString(s: string) {
      const b = s.split(/\D/);
      return b.reverse().join('-');
    }

    public static getTime() {
      const currentdate = new Date();
      let datetime =
        currentdate.getDay() +
        '/' +
        (currentdate.getMonth() + 1) +
        '/' +
        currentdate.getFullYear() +
        ' ' +
        currentdate.getHours() +
        ':' +
        currentdate.getMinutes();
      return datetime;
    }

    public static getTimeStampFromDate(date: string) {
      let subStringdate = date.substring(0, 10);
      let time = date.substring(11).replace(/\s/g, '');
      let tmpDate = this.reformatDateString(subStringdate);
      const validDate = tmpDate + ' ' + time;
      const newDate = new Date(validDate).getTime() / 1000;
      const gmt = newDate + 2 * 3600;
      return gmt;
    }
  };

  static StringFormatter = class {
    public static getInitial(name: string): string {
      return name.substring(0, 1).toUpperCase();
    }

    public static concatStr(arr: string[]) {
      if (Array.isArray(arr)) {
        let str: string = '';
        arr.forEach((item: string) => {
          if (str) {
            str = str + ',' + item;
          } else {
            str = item;
          }
        });
        return str;
      } else {
        return arr;
      }
    }

    public static capitalizeFirstLetter(string: string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    }
  };

  static DownloadFile = class {
    public static createDownLoadFile(blob: Blob, fileTyp: string, name: string): void {
      const a = window.document.createElement('a');
      a.href = window.URL.createObjectURL(blob);
      a.download = name + fileTyp;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    }
  };

  static Array = class {
    public static compareArrays(a1: any, a2: any) {
      return JSON.stringify(a1) == JSON.stringify(a2);
    }

    public static findValueByKey(array = [{ value: '', key: '' }], key: string) {
      for (let i = 0; i < array.length; i++) {
        if (array[i].value.includes(key)) {
          return array[i].key;
        }
      }
      return null;
    }

    public static deepCopy(array: any[] | {}) {
      return JSON.parse(JSON.stringify(array));
    }
  };

  static Foam = class {
    public static getSystem(type: string) {
      switch (type) {
        case 'Elastan':
          return 'Ultra-flexible binder/adhesive MDI based';
        case 'Elastocool':
          return 'Rigid foam';
        case 'Elastoflex':
          return 'Semi-rigid foam';
        case 'Elastofoam':
          return 'Flexible foam';
        case 'Elastopan':
          return 'Shoe sole foam';
        case 'Elastolit':
          return 'Integral rigid foam or compact system';
        case 'Elastopor':
          return 'Closed-cell polyurethane rigid foam';
        case 'Elastopir':
          return 'Rigid foam system based on Polyisocyanurate';
        default:
          return '';
      }
    }
  };
  static Tree = class {
    public static findCategoryIdx(children: TreeNode[], name: string) {
      return children.findIndex((x) => x.name === name);
    }

    public static setCategoryName(objCpyChild: TreeNode) {
      const name = objCpyChild.name as string;
      const splitName = name.split(':');
      return splitName[0];
    }

    public static copyData(treeNode: TreeNode): any {
      if (treeNode.data) {
        const index = treeNode.data.length - 1;
        const data = treeNode.data[index];
        const name = this.setCategoryName(treeNode);
        return { data: data, name: name, index: index + 1 };
      }
      return null;
    }

    public static findActor(obj: any): BoilerActorType {
      let type = obj.name as BoilerActorType;
      if (type.includes('Heat Exchanger')) {
        type = BoilerActorType.HEAT_EXCHANGER;
      }
      if (type.includes('Connection')) {
        type = BoilerActorType.CONNECTOR;
      }
      if (type.includes('Patch')) {
        type = BoilerActorType.PATCH;
      }

      return type;
    }

    public static findCategory(data: TreeNode[], name: string): number {
      return data.findIndex((x) => name.includes(x.name));
    }

    public static updateCategoryIdx(children: TreeNode[]): TreeNode[] {
      children.forEach((child, index) => {
        child.index = index;
      });

      return children;
    }
  };
}
